import { Settings } from './Settings.main';

export { Settings };
